import { useQuery } from "@tanstack/react-query";

import { fetchReviewTemplateV2 } from "../../../../../api/services/defs/review-templates";

export const useReviewTemplate = (templateId: string | null) => {
	return useQuery({
		queryKey: ["review-template-v2", templateId],
		queryFn: () => {
			if (!templateId) throw new Error("templateId is required");
			return fetchReviewTemplateV2(templateId);
		},
		enabled: Boolean(templateId),
		meta: { errorMessage: "There was an error loading the review template." },
	});
};
